import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=8c085d2e&scoped=true&lang=pug&"
import script from "./BannerItem.vue?vue&type=script&lang=ts&"
export * from "./BannerItem.vue?vue&type=script&lang=ts&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=8c085d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c085d2e",
  null
  
)

export default component.exports